



import StoreCategoryListComponent from "@/components/admin/storeCategory/storeCategoryListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "StoreCategoryListPage",
  components: {
    StoreCategoryListComponent,
  },
})
export default class StoreCategoryListPage extends Vue {}
